import { render } from "./OpenAnswerExercise.vue?vue&type=template&id=6009fc0a&ts=true"
import script from "./OpenAnswerExercise.vue?vue&type=script&lang=ts"
export * from "./OpenAnswerExercise.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__